export default class ValidationModel {
    errors: string[] = []
}
